import React from "react";

const EmptyTableMessage = ({ columns, message = "NINGUN DATO REGISTRADO" }) => {
    return (
        <tr>
            <td colSpan={columns} className="text-center p-3 text-muted">
                <p className="fw-bold fs-4">{message}</p>
            </td>
        </tr>
    );
};

export default EmptyTableMessage;
